"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = _interopRequireDefault(require("immutable"));

var _underscore = require("underscore");

var _usageTrackerRedux = require("usage-tracker-redux");

var _ActionTypes = _interopRequireDefault(require("../../constants/ActionTypes"));

var _GoodFiltersAndPage = _interopRequireDefault(require("../../constants/GoodFiltersAndPage"));

var _constants = require("./constants");

var _ActionTypes$FILTERS_;

var FILTERS_TO_TRACK = [_GoodFiltersAndPage.default.SORT_BY, _GoodFiltersAndPage.default.SUB_TYPE, _GoodFiltersAndPage.default.PAGE_LAYOUT, _GoodFiltersAndPage.default.INDUSTRY, _GoodFiltersAndPage.default.TEMPLATE_PURPOSE, _GoodFiltersAndPage.default.PROVIDER];

var filtersBeingUpdatedFromUrlNotUserInteraction = function filtersBeingUpdatedFromUrlNotUserInteraction(action) {
  return _immutable.default.Map.isMap(action.payload);
};

var getTrackAdjustedFilterPayload = function getTrackAdjustedFilterPayload(screen, value, filterType) {
  return {
    screen: screen,
    value_str: value,
    filter_type: filterType
  };
};

var _default = (_ActionTypes$FILTERS_ = {}, (0, _defineProperty2.default)(_ActionTypes$FILTERS_, _ActionTypes.default.FILTERS_OR_PAGE_UPDATED, function (action, state, dispatch) {
  if (filtersBeingUpdatedFromUrlNotUserInteraction(action)) {
    return;
  }

  var newParams = action.payload,
      meta = action.meta;
  var _meta$screen = meta.screen,
      screen = _meta$screen === void 0 ? _constants.Screens.DIRECTORY : _meta$screen;
  var value;
  var filterType;

  if (newParams[_GoodFiltersAndPage.default.SEARCH_TERM]) {
    value = newParams[_GoodFiltersAndPage.default.SEARCH_TERM];
    filterType = 'search';
  } else {
    var adjustedFilterArr = Object.keys((0, _underscore.pick)(newParams, FILTERS_TO_TRACK) || {});
    var adjustedFilter = adjustedFilterArr.length && adjustedFilterArr[0];

    if (adjustedFilter && (0, _underscore.isString)(newParams[adjustedFilter])) {
      value = newParams[adjustedFilter];
      filterType = adjustedFilter;
    }
  }

  if (value && filterType) {
    dispatch(_usageTrackerRedux.usageTrackerActions.track(_constants.EventTypes.ADJUSTED_FILTER, getTrackAdjustedFilterPayload(screen, value, filterType)));
  } else if (newParams[_GoodFiltersAndPage.default.LIMIT]) {
    dispatch(_usageTrackerRedux.usageTrackerActions.track(_constants.EventTypes.ADJUSTED_FILTER, getTrackAdjustedFilterPayload(screen, String(newParams.limit), _GoodFiltersAndPage.default.LIMIT)));
  }
}), (0, _defineProperty2.default)(_ActionTypes$FILTERS_, _ActionTypes.default.TRACK_MULTISELECT_SELECTION, function (action, state, dispatch) {
  var _action$payload = action.payload,
      adjustedFilter = _action$payload.adjustedFilter,
      selection = _action$payload.selection;
  dispatch(_usageTrackerRedux.usageTrackerActions.track(_constants.EventTypes.ADJUSTED_FILTER, getTrackAdjustedFilterPayload(_constants.Screens.DIRECTORY, selection, adjustedFilter)));
}), (0, _defineProperty2.default)(_ActionTypes$FILTERS_, _ActionTypes.default.CREATE_ASSET, function (action, state, dispatch) {
  var purchasedGoodsKey = action.payload.purchasedGoodsKey;
  dispatch(_usageTrackerRedux.usageTrackerActions.track(_constants.EventTypes.CREATED_ASSET, {
    screen: _constants.Screens.MANAGE_PURCHASES,
    value_str: state.managePurchases.getIn(['purchasedGoods', purchasedGoodsKey, 'subType'])
  }));
}), (0, _defineProperty2.default)(_ActionTypes$FILTERS_, _ActionTypes.default.UNINSTALL_GOOD, function (action, state, dispatch) {
  dispatch(_usageTrackerRedux.usageTrackerActions.track(_constants.EventTypes.UNINSTALL_GOOD, {
    screen: _constants.Screens.MANAGE_PURCHASES
  }));
}), (0, _defineProperty2.default)(_ActionTypes$FILTERS_, _ActionTypes.default.REDELIVERING_GOOD, function (action, state, dispatch) {
  dispatch(_usageTrackerRedux.usageTrackerActions.track(_constants.EventTypes.REDELIVER_GOOD, {
    screen: _constants.Screens.MANAGE_PURCHASES
  }));
}), (0, _defineProperty2.default)(_ActionTypes$FILTERS_, _ActionTypes.default.GOOD_INFO_CLICK, function (action, state, dispatch) {
  var trackingData = action.trackingData;
  dispatch(_usageTrackerRedux.usageTrackerActions.track(_constants.EventTypes.GOOD_INFO_CLICK, (0, _extends2.default)({
    screen: _constants.Screens.DETAILS
  }, Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2.default)(trackingData))))));
}), _ActionTypes$FILTERS_);

exports.default = _default;
module.exports = exports.default;